import { useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Header } from 'components/common'
import { axiosBase } from 'utils/functions'
import { getCsrfToken } from 'utils/csrf'
import PublicPageContainer from './PublicPageContainer'
import './AuthPages.scss'

interface ConfirmUnlockRouteParams {
  token: string
}

function ConfirmUnlockPage() {
  const { t } = useTranslation('pub', {
    keyPrefix: 'PublicRoutes.auth',
  })
  const { token } = useParams<ConfirmUnlockRouteParams>()
  const history = useHistory()
  const [error, setError] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleConfirm = async () => {
    setError('')
    setIsSubmitting(true)

    try {
      await axiosBase.post(
        '/users/unlock/confirm',
        { unlock_token: token },
        { headers: { 'x-csrf-token': getCsrfToken() } },
      )

      history.push('/login', { unlockSuccess: true })
    } catch (_error) {
      setError(t('unlock.unableToSend'))
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <PublicPageContainer>
      <div className="auth-page">
        <div className="auth-card">
          <Header as="h3" className="auth-title">
            {t('unlock.confirmUnlock')}
          </Header>

          <div className="auth-subtitle">{t('unlock.confirmClick')}</div>

          {error ? <div className="auth-error">{error}</div> : null}

          <div className="auth-form">
            <Button color="blue" onClick={handleConfirm} loading={isSubmitting}>
              {t('unlock.confirmBtn')}
            </Button>
          </div>

          <hr className="auth-divider" />
          <Link className="auth-link" to="/login">
            {t('all.login')}
          </Link>
          <Link className="auth-link" to="/forgot-password">
            {t('all.forgotPassword')}
          </Link>
        </div>
      </div>
    </PublicPageContainer>
  )
}

export default ConfirmUnlockPage
